import { z } from "zod";

import http from "@/services/http";

const badge = z.object({
  data: z.array(
    z.object({
      id: z.string(),
      badge_template: z.object({
        primary_badge_template_id: z.string().nullish(),
        name: z.string(),
        type_category: z.string().nullish(),
      }),
      image_url: z.string(),
      issued_at: z.string(),
      expires_at: z.string().nullish(),
    })
  ),
  metadata: z.object({
    next_page_url: z.string().nullable(),
    previous_page_url: z.string().nullable(),
  }),
});
const badgeData = z.object({
  badgeName: z.string().nullish(),
  badgeImageUrl: z.string().nullish(),
});

const credlyProfileData = z.object({
  userBadgeUrl: z.string().nullish(),
  userProfileUrl: z.string().nullish(),
});

export async function fetchPreRequisiteCourseStatus(course_id: string) {
  if (!window.env.API_BADGING || !course_id) {
    return;
  }
  const { data } = await http().get(
    window.env.API_BADGING + "/badge/validate/" + course_id
  );
  return data;
}
export async function fetchBadges() {
  if (!window.env.API_BADGING) {
    return;
  }
  const { data } = await http().get(`${window.env.API_BADGING}/badges`);

  if (!data) {
    return;
  }
  return badge.parse(data);
}

export async function courseBadge(courseId: string) {
  if (!window.env.API_BADGING) {
    return;
  }
  const { data } = await http().get(
    `${window.env.API_BADGING}/badge/${courseId}`
  );

  if (!data) {
    return;
  }
  return badgeData.parse(data);
}

export async function credlyProfile(courseId: string) {
  if (!window.env.API_BADGING) {
    return;
  }
  const { data } = await http().get(
    `${window.env.API_BADGING}/user/badge/${courseId}`
  );

  if (!data) {
    return;
  }
  return credlyProfileData.parse(data);
}
